// @flow
import * as React from 'react';
import ExperimentsClient from 'app/common/lib/ExperimentsClient';
import PropTypes from 'prop-types';
import QuickPerf from 'app/common/lib/logging/QuickPerf';
import type { ClientContext } from 'app/common/lib/context';
import { RequestContextProvider } from 'app/common/react/components/RequestContext';
import { RequestContextFactory, type RequestContext } from 'app/common/lib/RequestContext';

type Props = {
  children: React.Node,
  context: ClientContext,
  experiments: ExperimentsClient,
  seoExperiments: ExperimentsClient,
  seoUnauthExperiments: ExperimentsClient,
};

export default class Context extends React.Component<Props> {
  getChildContext() {
    return {
      language: this.props.context.language,
      locale: this.props.context.locale,
      unauthId: this.props.context.unauth_id,
      origin: this.props.context.origin,
    };
  }

  componentDidMount() {
    const requestContext = this.getRequestContext(this.props);
    if (QuickPerf.enabled(requestContext)) {
      window.requestAnimationFrame(() => {
        QuickPerf.logFromClient('authContext', this.props.context);
      });
    }
  }

  getRequestContext(props: Props): RequestContext {
    return RequestContextFactory.fromDesktopContextProps(props);
  }

  render() {
    return (
      <RequestContextProvider value={this.getRequestContext(this.props)}>
        {this.props.children}
      </RequestContextProvider>
    );
  }
}

Context.childContextTypes = {
  language: PropTypes.string,
  locale: PropTypes.string,
  unauthId: PropTypes.string,
  origin: PropTypes.string,
};

Context.propTypes = {
  children: PropTypes.node.isRequired,
  context: PropTypes.shape({
    is_bot: PropTypes.oneOf(['true', 'false']),
    language: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    unauth_id: PropTypes.string.isRequired,
    origin: PropTypes.string.isRequired,
  }).isRequired,
  experiments: PropTypes.instanceOf(ExperimentsClient).isRequired,
  seoExperiments: PropTypes.instanceOf(ExperimentsClient).isRequired,
  seoUnauthExperiments: PropTypes.instanceOf(ExperimentsClient).isRequired,
};
